var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetCallHistoryAction, SetCallHistoryParamsAction } from '../call-history.actions';
import * as moment from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { getCallHistoryCallsSelector, getCallHistoryPageSelector, getCallHistoryTotalSelector, initialState } from '../call-history.reducer';
import { ContactsService } from '../../contacts/shared/services/contacts.service';
import { CallHistoryService } from '../call-history.service';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { DatePickerService } from "../../shared/services/date.picker.service";
var CallHistoryListComponent = /** @class */ (function () {
    function CallHistoryListComponent(route, store, callHistoryService, contactsService, datePickerService, location) {
        this.route = route;
        this.store = store;
        this.callHistoryService = callHistoryService;
        this.contactsService = contactsService;
        this.datePickerService = datePickerService;
        this.location = location;
        this.displayedColumns = ['direction', 'contactName', 'callTime', 'agentName', 'callLength', 'appType'];
        this.filters = {};
        this.utcOffset = moment().utcOffset();
        this.pageSizeOptions = [10, 20, 100];
        this.allNumbersSelected = false;
        this.allUsersSelected = false;
        this.datePickerOpened = false;
        this.callsHistoryLimit = 0;
        this.initialFilters = initialState.params;
        this.keepFilters = false;
    }
    CallHistoryListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.maxDate = moment().endOf('day').add(this.utcOffset / 60, 'hours').toISOString();
        this.startDate = this.toHour(moment().subtract(7, 'day').startOf('day').add(this.utcOffset / 60, 'hours'), this.utcOffset);
        this.endDate = this.toHour(moment().endOf('day').add(this.utcOffset / 60, 'hours'), this.utcOffset);
        this.keepFilters = this.route.snapshot.queryParamMap.get('keepFilters') === 'true';
        this.msisdns = this.route.snapshot.data['msisdns'];
        this.phoneNumbersIds = this.msisdns.map(function (number) { return number.id; });
        this.basicUsers = this.route.snapshot.data['users'];
        this.users = this.basicUsers.filter(function (user) { return user.id === null; }).length
            ? this.basicUsers
            : this.basicUsers.concat([{ id: CallHistoryService.UNASSIGNED_USER_ID, name: 'UNASSIGNED' }]);
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.data = this.route.snapshot.data['callHistory'].data;
        this.dataSource.sort = this.sort;
        this.total = this.route.snapshot.data['callHistory'].total;
        this.initialFilters = {
            sortBy: 'callTime',
            order: 'DESC',
            dateFrom: moment()
                .startOf('day')
                .subtract(7, 'days')
                .toISOString(),
            dateTo: moment()
                .toISOString(),
            pager: {
                pageIndex: 0,
                pageSize: 10,
                previousPageIndex: 0
            }
        };
        this.store.select(getCallHistoryCallsSelector).subscribe(function (calls) {
            _this.dataSource.data = calls;
        });
        this.store.select(getCallHistoryTotalSelector).subscribe(function (total) {
            _this.total = total;
            _this.paginator.length = total;
        });
        this.store.select(getCallHistoryPageSelector).subscribe(function (params) {
            _this.filters = params;
            if (_this.filters && _this.filters.pager) {
                var _a = _this.filters.pager || {}, pageSize = _a.pageSize, pageIndex = _a.pageIndex;
                _this.paginator.pageSize = pageSize;
                _this.paginator.pageIndex = pageIndex;
            }
        });
        this.store.select(getLimitsSelector).subscribe(function (limits) {
            _this.callsHistoryLimit = limits.callsHistoryLimit;
            _this.minDate = _this.contactsService.calculateMinDateByLimit(limits.callsHistoryLimit, _this.utcOffset);
        });
        this.datePickerService.onTogglePicker.subscribe(function (open) {
            _this.opens = open && open.open ? open.open : 'left';
            _this.datePickerOpened = open && open.show;
        });
        if (!this.keepFilters) {
            this.filters = this.initialFilters;
            this.store.dispatch(new GetCallHistoryAction(this.filters));
        }
    };
    CallHistoryListComponent.prototype.toHour = function (date, utcOffset) {
        return date.toISOString();
    };
    CallHistoryListComponent.prototype.toggleAllNumbersSelect = function () {
        this.allNumbersSelected = !this.allNumbersSelected;
    };
    CallHistoryListComponent.prototype.toggleAllUsersSelect = function () {
        this.allUsersSelected = !this.allUsersSelected;
    };
    CallHistoryListComponent.prototype.addFilter = function (type, value) {
        this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
    };
    CallHistoryListComponent.prototype.addDisplayParams = function (event) {
        this.filters.pager = __assign({}, this.filters.pager, event);
        this.store.dispatch(new GetCallHistoryAction(this.filters));
    };
    CallHistoryListComponent.prototype.ngOnDestroy = function () {
        if (!this.keepFilters) {
            this.store.dispatch(new SetCallHistoryParamsAction(this.initialFilters));
        }
    };
    CallHistoryListComponent.prototype.callsTableDetailsClicked = function () {
        this.location.replaceState('/call-history?keepFilters=true');
        this.keepFilters = true;
    };
    CallHistoryListComponent.prototype.dateFilterChange = function ($event) {
        this.startDate = $event.dateFrom.isAfter(this.minDate) ? $event.dateFrom : this.minDate;
        this.endDate = $event.dateTo;
        this.filters.dateFrom = $event.dateFrom.toISOString();
        this.filters.dateTo = $event.dateTo.toISOString();
        this.store.dispatch(new GetCallHistoryAction(this.filters));
    };
    return CallHistoryListComponent;
}());
export { CallHistoryListComponent };
